// extracted by mini-css-extract-plugin
module.exports = {"card":"lecture-card-module--card--NeNm6"};